import React from 'react';
import { PlcColor } from '@styles/colors';
import { SvgProps } from './icon.types';

function CloseCircleIcon({ fill = PlcColor.GREY_CLOUD_MEDIUM, fillColor = '#2D3049', ...props }: SvgProps) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10-5.52285 0-10 4.47715-10 10 0 5.5228 4.47715 10 10 10z"
        fill={fill}
      />
      <path
        d="m13.0594 12.0001 2.3-2.29999c.29-.29.29-.77 0-1.06s-.77-.29-1.06 0l-2.3 2.29999-2.30003-2.29999c-.29-.29-.77-.29-1.05999 0-.29.29-.29.77 0 1.06l2.30002 2.29999-2.30002 2.3c-.29.29-.29.77 0 1.06.15.15.33999.22.52999.22s.38-.07.53-.22l2.30003-2.3 2.3 2.3c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06z"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth=".5"
      />
    </svg>
  );
}

export { CloseCircleIcon };
